import React from 'react';
import PropTypes from 'prop-types';
import './StepIndicator.scss';

const StepIndicator = ({ steps, currentStep }) => {
   return (
      <div className="step-indicator-container">
         <div className="step-indicator">
            {steps.map((step, index) => {
               const stepNumber = index + 1;
               const isActive = currentStep === stepNumber;
               const isCompleted = currentStep > stepNumber;
               
               return (
                  <React.Fragment key={stepNumber}>
                     <div className={`step-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
                        <div className="step-circle">
                           {isCompleted ? (
                              <span className="checkmark">✓</span>
                           ) : (
                              <span className="step-number">{stepNumber}</span>
                           )}
                        </div>
                        <div className="step-label">{step.label}</div>
                     </div>
                     {index < steps.length - 1 && (
                        <div className={`step-line ${currentStep > stepNumber ? 'completed' : ''}`}></div>
                     )}
                  </React.Fragment>
               );
            })}
         </div>
      </div>
   );
};

StepIndicator.propTypes = {
   steps: PropTypes.arrayOf(
      PropTypes.shape({
         label: PropTypes.string.isRequired,
      })
   ).isRequired,
   currentStep: PropTypes.number.isRequired,
};

export default StepIndicator;
